import { z } from 'zod';

/**
 * The zod every schema uses. Its built-in messages follow the locale (`localeStore.apply`);
 * custom messages are English keys that the form fields translate (docs/conventions/i18n.md).
 */
export const zs = z;
